module.exports = __webpack_public_path__ + "static/media/img-leon.30a943ef.jpg";